import Router from 'next/router'
import { GetUserDetails } from './config'
import { IUserDetails, IUserType } from '../interfaces/user.interface'
import { ISchool } from '../interfaces/school.interface'
import moment from 'moment'
import { envConfig } from './envConfig'
import { ILiveClassPlatform } from '../components/Schedules/ILiveClassSchedule'
import { ISchoolBlog } from '../components/Blogs/useBlogs'
import { ISchoolDiscussion } from '../interfaces/IDiscussion'
import lz from 'lzutf8'
import { ICourse } from '../interfaces/ICourse'
import { ICategory } from '../interfaces/ICategory'

export const getLiveClassUrl = (
  school: ISchool,
  class_id: string,
  scheduleId: string,
) => {
  const schoolUrl = `https://${getSchoolActiveDomainName(school)}`
  const liveClassUrl = `${schoolUrl}/courses/live/${class_id}/${scheduleId}`
  return liveClassUrl
}

export const redirectForSchoolLiveClass = (
  school_details: any,
  class_id: string,
) => {
  // redirect to /live if the path doesnt start with /live
  const school_live_class_path = 'courses/live' // starts with /live
  const school_live_class_type = 'school_live_class' //seen in the db
  school_details = school_details || {}
  const myLocation = window.location.pathname
  const _pathnameArray = myLocation.split('/')
  const firstPath = _pathnameArray ? _pathnameArray[1] : ''
  console.log('redirtect', firstPath, school_details)
  if (
    school_details.school_type === school_live_class_type &&
    firstPath !== school_live_class_path
  ) {
    console.log('School is a school_live_class')
    Router.push('/' + school_live_class_path + '/' + class_id)
    return
  }
}

export const checkUserLogin = () => {
  const user_details = GetUserDetails()
  // console.log("checking user login status")
  try {
    const pathname = location.pathname

    if (
      !user_details &&
      pathname !== '/login' &&
      pathname !== '/register' &&
      pathname !== '/'
    ) {
      goToLoginUrlWithRedirect()
      // location.href = `${location.origin}/login?&redirect=${redirect_url}`;
    }
  } catch (error) {
    console.log('error in checking user login', error)
  }
}

export const goToLoginUrlWithRedirect = () => {
  const redirect_url = location.href
  goToUrlWithRedirect('login', redirect_url)
}

export const goToUrlWithRedirect = (path: string, redirectUrl: string) => {
  location.href = `${location.origin}/${path}?&redirect=${redirectUrl}`
}

export const redirectOnAuthSuccess = (fullRedirectUrlHref: string) => {
  console.log('redirect url', fullRedirectUrlHref)
  window.location.href = fullRedirectUrlHref || window.location.origin
}

export const logoutAndClearCache = () => {
  console.log('About to logout and clear cache')
  localStorage.clear()
  sessionStorage.clear()
  location.reload()
}

export const downloadImageFromDataImage = (
  filename: string,
  dataImage: string,
) => {
  const element = document.createElement('a')
  // element.setAttribute(
  //   "href",
  //   "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  // );

  element.setAttribute('href', dataImage)
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

export const schoolIsInNigeria = (currencyCode: string): boolean => {
  return currencyCode ? currencyCode.trim().toLowerCase() === 'ngn' : false
}

export const userIsNigerian = () => {
  if (typeof localStorage === 'undefined') return
  const userDetails = GetUserDetails()
  return userDetails?.country?.toLowerCase() === 'nigeria'
}

export const getStudentLink = (student_id: string, school_id: string) => {
  return `${location.origin}/school-details/${school_id}/student-details/${student_id}`
}

export const isUserATeacherOrAccountOwnerOrAdmin = (
  userType: IUserType | undefined,
): boolean => {
  return ['teacher', 'admin', 'account_user'].includes(userType as any)
}

export const isUserATeacherOrAdminOrStudent = (
  userType: IUserType,
): boolean => {
  return ['teacher', 'admin', 'student'].includes(userType)
}

export const getSchoolActiveDomainName = (school: ISchool): string => {
  const customDomain = school.custom_domain?.domain_name
  if (customDomain) {
    return customDomain
  }

  if (school?.whitelabel_referrer?.root_domain) {
    return `${school.school_url}.${school?.whitelabel_referrer?.root_domain}`
  }

  return `${school.school_url}.pledre.school`
}

export const isWhitelabelSchool = (school: ISchool): boolean => {
  return !!school?.whitelabel_referrer?.root_domain // if root_domain is set then its a whitelabel school
}

export const isSchoolBillingProfileValid = (school: ISchool): boolean => {
  return [
    'whitelabel_subscription',
    'subscription',
    'enterprise',
    'commission',
  ].includes(school.account_user_plans?.plan_name || '')
}

export const isSchoolBillingProfileSubscription = (
  school: ISchool,
): boolean => {
  return school.account_user_plans?.plan_name === 'subscription'
}

export const isSchoolBillingProfileCommission = (school: ISchool): boolean => {
  return school.account_user_plans?.plan_name === 'commission'
}

export const isSchoolBillingProfileSubscriptionOrEnterprise = (
  school: ISchool,
): boolean => {
  return ['subscription', 'enterprise'].includes(
    school.account_user_plans?.plan_name || '',
  )
}

export const isSchoolBillingProfileCommissionOrSubscriptionOrEnterprise = (
  school: ISchool,
): boolean => {
  return ['subscription', 'enterprise', 'commission'].includes(
    school.account_user_plans?.plan_name || '',
  )
}

export const isPledreSupport = (userDetails?: IUserDetails) => {
  return ['support@pledre.com', 'demi@pledre.com'].includes(
    userDetails?.email || '',
  )
}

export const allowAddStudentToCourse = (
  schoolDetails: ISchool,
  userDetails: IUserDetails,
) => {
  const isPledreSupport = userDetails?.email === 'support@pledre.com'

  const dontAllow =
    isSchoolBillingProfileCommission(schoolDetails) &&
    !isPledreSupport &&
    !schoolDetails?.allow_manual_student_approval

  return !dontAllow
}

export const hasSubscriptionReachedMaximumNumberStudent = (
  school: ISchool,
): boolean => {
  return false // return false since we changed pricing model

  if (school.account_user_plans?.plan_name !== 'subscription') {
    return false
  }

  const no_of_selected_students = school.account_user_plans?.no_of_student || 0
  const no_of_active_students = school?.numberOfActiveStudents || 0

  return no_of_active_students >= no_of_selected_students
}

export const getDisplayUserType = (userType: IUserType) => {
  switch (userType) {
    case 'account_user':
      return 'School owner'
    case 'admin':
      return 'Admin'
    case 'teacher':
      return 'Teacher'
    case 'student':
      return 'Student'
    default:
      return 'Unknown'
  }
}

export const disableUserAccessDueToBillingProfile = (
  schoolDetails: ISchool,
) => {
  const enableCheckForSchool = moment(schoolDetails.created_at).isAfter(
    newBillingStartDate,
  )
  const validBillingProfile = isSchoolBillingProfileValid(schoolDetails)
  return (
    enableCheckForSchool &&
    !validBillingProfile &&
    !isWhitelabelSchool(schoolDetails)
  )
}

export const isAfterNewBillingFlowStartDate = () => {
  return moment().isAfter(newBillingStartDate)
}

// for billing v2 we removed commission and locked features until user belongs to a plan
// starts 4th of november
export const newBillingStartDate = moment('2021-11-03T00:00:00.000Z').toDate()

export const BILLING_DISCOUNT_GOOGLE_FORM =
  'https://docs.google.com/forms/d/1Dhn73IrOIKu6xWr1A2ptxjMd_m51ZHTL3YAM0zRF074/edit?ts=6181b71b'

type IPaymentProvider = 'paystack' | 'flutterwave' | 'stripe'

export const retrieveSchoolPaymentProvider = (
  schoolDetails: ISchool,
): IPaymentProvider => {
  // for african payment. If NEXT_PUBLIC_PRIMARY_PAYMENT is paystack use paystack
  // for african payment. If NEXT_PUBLIC_PRIMARY_PAYMENT is flutterwave use flutterwave
  // else use stripe is stripe is enabled
  // else use last resort = flutterwave

  const localCurrencySupport = ['NGN', 'GHS', 'KES', 'ZAR']

  if (
    localCurrencySupport.includes(schoolDetails.currency_code) &&
    envConfig.NEXT_PUBLIC_PRIMARY_PAYMENT === 'paystack'
  ) {
    return 'paystack'
  }

  if (
    localCurrencySupport.includes(schoolDetails.currency_code) &&
    envConfig.NEXT_PUBLIC_PRIMARY_PAYMENT === 'flutterwave'
  ) {
    return 'flutterwave'
  }

  if (envConfig.NEXT_PUBLIC_ENABLE_STRIPE) {
    return 'stripe'
  }

  return 'flutterwave'
}

export const liveClassPlatformName = (
  liveClassPlatform: ILiveClassPlatform,
) => {
  switch (liveClassPlatform) {
    case 'google_meet':
      return 'Google meet'
    case 'pledre':
      return 'Integrated live class'
    case 'zoom':
      return 'Zoom conferencing'
    default:
      return 'Pledre live class'
  }
}

export const MyColorArray = [
  '#8b2958',
  '#1d43a7',
  '#278a5b',
  '#464464',
  '#3b71ff',
]

export function customSpeak(opts: { text: string }) {
  const msg = new SpeechSynthesisUtterance()
  msg.text = opts.text
  window.speechSynthesis.speak(msg)
}

export function stopCustomSpeaking() {
  window.speechSynthesis.cancel()
}

export const formatAmount = (amount: number | string) => {
  if (!amount) return ''
  return amount.toLocaleString('en-US')
}

function deep<T>(source: T) {
  return JSON.parse(JSON.stringify(source))
}

function deepObject<T extends object>(source: T) {
  const result = {} as T
  Object.keys(source).forEach(key => {
    const value = source[key as keyof T]
    result[key as keyof T] = deep(value)
  }, {})
  return result as T
}

function deepArray<T extends any[]>(collection: T): any {
  return collection.map(value => {
    return deep(value)
  })
}

export function deepCopy<T extends object>(value: T): T {
  if (typeof value !== 'object' || value === null) {
    return value
  }
  if (Array.isArray(value)) {
    return deepArray(value)
  }
  return deepObject(value)
}

export const generateArticleUrl = (post: ISchoolBlog) => {
  return `/articles/${post.slug ? post.slug : post._id}`
}

export const generateDiscussionDetailsPageUrl = (opts: {
  discussion: ISchoolDiscussion
  school: ISchool
}) => {
  return `https://${getSchoolActiveDomainName(
    opts.school,
  )}/discussion?discussion_details=${opts.discussion?._id}`
}

export const generateDiscussionListPageUrl = (opts: { school: ISchool }) => {
  return `https://${getSchoolActiveDomainName(opts.school)}/discussion`
}

export const lzutf8EncodeCompressData = (data: any) => {
  return lz.encodeBase64(lz.compress(data))
}

export const lzutf8DecodeDecompressData = (data: any) => {
  return lz.decompress(lz.decodeBase64(data))
}

export const generateLiquidDataForLandingPage = (school: ISchool) => {
  return {
    pledreSchoolData: {
      name: school?.name,
      tagline: school?.tagline,
      logo: school?.logo,
      details: school?.details,
      email: school?.email,
      phone_no: school?.phone_no,
      school_url: school?.school_url,
      active_domain: school ? getSchoolActiveDomainName(school) : '',
      show_category: school?.show_category,
      show_forum: school?.show_forum,
      show_active_chats: school?.show_active_chats,
      show_course_cluster: school?.show_course_cluster,
      school_bank: school?.school_bank,
      school_bank_account_no: school?.school_bank_account_no,
      school_bank_swift_code: school?.school_bank_swift_code,
      hide_school_banner: school?.hide_school_banner,
      hide_school_video_carousel_banner:
        school?.hide_school_video_carousel_banner,
      background_image: school?.background_image,
      preview_image: school?.preview_image,
      color_scheme: school?.color_scheme,
      currency_code: school?.currency_code,
      currency_symbol: school?.currency_symbol,
      school_testimonials: school?.school_testimonials,
      show_all_course: school?.show_all_course,
      course_summary: school?.course_summary,
      categories_summary: school?.categories_summary,
      articles_summary: school?.articles_summary,
      programs_summary: school?.programs_summary,
      additional_links: school?.additional_links,
      courses: school?.courses,
    },
  }
}

export const generateCategoryHomepageUrl = (opts: {
  school: ISchool
  category: Partial<ICategory>
}) => {
  const schoolUrl = `https://${getSchoolActiveDomainName(opts.school)}`
  return `${schoolUrl}#${opts.category?.slug}`
}

export const showCoursePayButtonOnCourseDetailsPage = (_opts: {
  courseDetails: ICourse
}) => {
  // if necessary extend later to set this based on course settings
  return false
}

export const allowAddMailchimpSettings = (schoolDetails: ISchool) => {
  const enable = ['demi', 'demischool'].includes(
    schoolDetails?.school_url || '',
  )
  return !!enable
}

export const enableLoanInSchool = (schoolDetails: ISchool) => {
  const enable = ['demi', 'demischool', 'halolabacademy', 'mock'].includes(
    schoolDetails?.school_url || '',
  )
  return !!enable
}

export const BULK_STUDENTS_UPLOAD_FILE_URL =
  '/static/csv_templates/bulk-students-upload.csv'

export const BULK_FACULTY_STUDENTS_UPLOAD_FILE_URL =
  '/static/csv_templates/bulk-faculty-students-upload.csv'
